import React, { useEffect, useRef, useState } from 'react'
import { Grid, useMediaQuery, useTheme } from '@material-ui/core'
import {
  Button,
  SWAPSpace,
  Typography,
  Chip,
  Card,
  Paper,
  Snackbar,
} from '@yosgo/swap-ui'
import CountUp from 'react-countup'

import Navigation from './Navigation'
import Footer from '../Common/Footer'
import { AppHomeHead } from '../Common/PagesHead'
import LoadToShow from '../Common/LoadToShow'
import Image from 'next/image'
import {
  GetCaseGroupItemsFromSOHO,
  GetJoinedCaseGroupsFromSOHO,
  GetMember,
  GetStatisticsFromGuess,
} from '../../utils/AppRequest'
import { CGIR, NewsItem } from '../Member/Group/NewsBlock'
import Swiper from 'swiper'
import { Link } from '@material-ui/core'
import CaseCard from '../Member/Group/CaseCard'
import Slider from 'react-slick'
import MySlider from './Slider'
import axios from 'axios'
import LazyLoadImg from '../Common/LazyLoadImg'
import { ParseAccountToken } from '../../utils/HandleToken'
import AuthModal from '../Common/AuthModal'
import JoinModal from '../Member/Group/JoinModal'
import ApplyModal from '../Member/Group/ApplyModal'
import { GroupItem } from '../Layouts/group/layout'
import { testimonialData } from './Pricing'

const backgroundColor = '#E6E9F8'
const backgroundColorGray = '#F9F9F9'

//Hero 區域
const EmptyUserCard = ({ block }: { block?: boolean }) => {
  return (
    <div
      style={{
        width: 80,
        height: 80,
        borderRadius: 8,
        backgroundColor: block ? '#C1C7ED' : 'unset',
      }}
    />
  )
}
const UserCard = ({ image }: { image: string }) => {
  return (
    <div
      style={{
        width: 80,
        height: 80,
        border: '1px solid #ffffff',
        borderRadius: 8,
        backgroundColor: '#F9F9F9',
        overflow: 'hidden',
        boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.10)',
      }}
    >
      <LazyLoadImg
        height={80}
        width={80}
        src={image}
        objectFit="cover"
        alt="user image"
        placeholder="blur"
        blurDataURL={image}
      />
    </div>
  )
}
interface SideCardData {
  image: string
  block: boolean
}
const avatarPrefix =
  'https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/img_profile/img_profile+_'
const leftSideCardData: SideCardData[] = [
  { image: `${avatarPrefix}01.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}02.png`, block: false },
  { image: `${avatarPrefix}03.png`, block: false },
  { image: '', block: false },
  { image: '', block: true },
  { image: `${avatarPrefix}06.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}09.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}10.png`, block: false },
  { image: '', block: false },
  { image: '', block: true },
  { image: `${avatarPrefix}13.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}14.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}16.png`, block: false },
  { image: `${avatarPrefix}17.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}20.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}21.png`, block: false },
  { image: '', block: false },
  { image: '', block: false },
  { image: '', block: true },
  { image: '', block: false },
  { image: `${avatarPrefix}24.png`, block: false },
  { image: `${avatarPrefix}27.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}28.png`, block: false },
  { image: '', block: true },
]
const rightSideCardData: SideCardData[] = [
  { image: '', block: true },
  { image: '', block: false },
  { image: `${avatarPrefix}04.png`, block: false },
  { image: `${avatarPrefix}05.png`, block: false },
  { image: `${avatarPrefix}07.png`, block: false },
  { image: `${avatarPrefix}08.png`, block: false },
  { image: '', block: false },
  { image: '', block: false },
  { image: '', block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}11.png`, block: false },
  { image: `${avatarPrefix}12.png`, block: false },
  { image: '', block: false },
  { image: '', block: true },
  { image: '', block: false },
  { image: `${avatarPrefix}15.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}18.png`, block: false },
  { image: `${avatarPrefix}19.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}22.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}23.png`, block: false },
  { image: '', block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}25.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}26.png`, block: false },
  { image: `${avatarPrefix}29.png`, block: false },
  { image: '', block: false },
  { image: `${avatarPrefix}30.png`, block: false },
  { image: '', block: true },
]
const LeftSideCards = () => {
  const theme = useTheme()
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const [list, setList] = useState<SideCardData[]>([])

  useEffect(() => {
    const _data = leftSideCardData.reduce(
      (ary: SideCardData[], item: SideCardData, index) => {
        if (lgDown && index % 4 === 3) {
          return ary
        }
        if (smDown && index % 4 === 2) {
          return ary
        }
        return [...ary, item]
      },
      []
    )
    setList(_data)
  }, [lgDown, smDown])

  return (
    <div
      style={{
        width: smDown ? 176 : lgDown ? 264 : 352,
        position: 'absolute',
        top: 0,
        left: 0,
        paddingTop: 'calc(56px + 8px)',
        paddingLeft: 4,
        paddingRight: 4,
      }}
    >
      <Grid container spacing={1}>
        {list.map((item: { image: string; block: boolean }, index: number) => (
          <Grid key={index} item xl={3} md={4} sm={6}>
            {item.image ? (
              <UserCard image={item.image} />
            ) : (
              <EmptyUserCard block={item.block} />
            )}
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
const RightSideCards = () => {
  const theme = useTheme()
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const [list, setList] = useState<SideCardData[]>([])

  useEffect(() => {
    const _data = rightSideCardData.reduce(
      (ary: SideCardData[], item: SideCardData, index) => {
        if (lgDown && index % 4 === 0) {
          return ary
        }
        if (smDown && index % 4 === 1) {
          return ary
        }
        return [...ary, item]
      },
      []
    )
    setList(_data)
  }, [lgDown, smDown])

  return (
    <div
      style={{
        width: smDown ? 176 : lgDown ? 264 : 352,
        position: 'absolute',
        top: 0,
        right: 0,
        paddingTop: 'calc(56px + 8px)',
        paddingLeft: 4,
        paddingRight: 4,
      }}
    >
      <Grid container spacing={1}>
        {list.map((item: { image: string; block: boolean }, index: number) => (
          <Grid key={index} item xl={3} md={4} sm={6}>
            {item.image ? (
              <UserCard image={item.image} />
            ) : (
              <EmptyUserCard block={item.block} />
            )}
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
const HeroComponent = ({
  setAuthModal,
}: {
  setAuthModal: (show: boolean) => void
}) => {
  const theme = useTheme()
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))

  const handleButtonClick = () => {
    // GA 紀錄點擊事件

    if (!ParseAccountToken()) {
      setAuthModal(true)
      return
    }
    window.location.href = '/member'
  }

  return (
    <div
      style={{
        backgroundColor,
        position: 'relative',
        height: 768,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SWAPSpace size={lgDown ? 80 : 120} />
      <div className="swap-container">
        <LeftSideCards />
        <RightSideCards />
        <div style={{ position: 'relative' }}>
          {/* 背景模糊區塊 */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            position: 'absolute',
            zIndex: 1,
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: smDown ? 840 : 968,
            height: smDown ? 840 : 968,
            borderRadius: '50%',
          }}>
            <div style={{
              width: smDown ? 640 : 768,
              height: smDown ? 640 : 768,
              borderRadius: '50%',
              background: 'radial-gradient(50% 50% at 50% 50%, #E6E9F8 80.08%, rgba(230, 233, 248, 0.50) 90.15%, rgba(230, 233, 248, 0.00) 100%)',
              filter: 'blur(40px)'
            }} />
          </div>
          <div style={{
            position: 'relative',
            zIndex: 2,
          }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography variant={'h1'} color="primary400" style={{ fontSize: smDown ? 40 : 60 }}>
                自由
              </Typography>
              <Typography
                variant={'h1'}
                color="black1000"
                style={{ fontSize: smDown ? 40 : 60 }}
              >
                但不孤獨
              </Typography>
            </div>
            <SWAPSpace size={8} />
            <Typography
              variant={smDown ? 'h6' : 'h4'}
              color="black1000"
              style={{ textAlign: 'center' }}
            >
              SWAP 自由工作者的支援好夥伴
            </Typography>
            <SWAPSpace size={32} />
            <div
              style={{
                display: 'flex',
                flexDirection: smDown ? 'column' : 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: smDown ? 0 : 16,
                  marginBottom: smDown ? 8 : 0,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 24,
                    height: 24,
                    backgroundColor: '#F9F9F9',
                    border: '1px solid #ffffff',
                    borderRadius: 6,
                  }}
                >
                  {hero_money_icon}
                </div>
                <Typography
                  variant={'body2_loose'}
                  color="black800"
                  style={{ marginLeft: 8 }}
                >
                  財務管理，發票請款
                </Typography>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginRight: smDown ? 0 : 16,
                  marginBottom: smDown ? 8 : 0,
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 24,
                    height: 24,
                    backgroundColor: '#F9F9F9',
                    border: '1px solid #ffffff',
                    borderRadius: 6,
                  }}
                >
                  {hero_file_icon}
                </div>
                <Typography
                  variant={'body2_loose'}
                  color="black800"
                  style={{ marginLeft: 8 }}
                >
                  接案履歷，曝光媒合
                </Typography>
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 24,
                    height: 24,
                    backgroundColor: '#F9F9F9',
                    border: '1px solid #ffffff',
                    borderRadius: 6,
                  }}
                >
                  {hero_member_icon}
                </div>
                <Typography
                  variant={'body2_loose'}
                  color="black800"
                  style={{ marginLeft: 8 }}
                >
                  接案社團，拓展案源
                </Typography>
              </div>
            </div>
            <SWAPSpace size={32} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                style={{ width: smDown ? 254 : 240 }}
                size="large"
                onClick={handleButtonClick}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ marginRight: 4 }}>立即加入</span>
                  {arrow_right_white_icon}
                </div>
              </Button>
            </div>
          </div>
        </div>
        {/* 下方旋轉提示字 */}
        {smDown ? null : (
          <div
            style={{
              position: 'absolute',
              zIndex: 3,
              bottom: 0,
              left: '50%',
              transform: 'translate(-50%, 0)',
              width: 120,
              height: 120,
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: 27,
                left: 0,
                width: 120,
                height: 120,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundImage: `url('${
                  require('./assets/text.png').default.src
                }')`,
                animation: 'rotate 12s linear infinite',
              }}
            />
            <div
              style={{
                position: 'absolute',
                top: 'calc(50% + 27px)',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              {arrow_down_blue_icon}
            </div>
          </div>
        )}
      </div>
      <SWAPSpace size={40} />
    </div>
  )
}

// 履歷區域
const ResumeComponent = ({
  setAuthModal,
}: {
  setAuthModal: (show: boolean) => void
}) => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down(961))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))

  const handleButtonClick = () => {
    if (!ParseAccountToken()) {
      setAuthModal(true)
      return
    }
    window.location.href = '/member'
  }

  return (
    <div>
      <SWAPSpace size={smDown ? 40 : 120} />
      <div className="swap-container">
        <div
          style={{
            display: 'flex',
            flexDirection: mdDown ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: mdDown ? 'unset' : 420,
              marginRight: mdDown ? 0 : 100,
            }}
          >
            <Typography variant={mdDown ? 'h4' : 'h2'} color="black1000">
              一頁管理專業成就
            </Typography>
            <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
              <Typography variant={mdDown ? 'h4' : 'h2'} color="black1000">
                從建立
              </Typography>
              <Typography
                variant={mdDown ? 'h4' : 'h2'}
                color="primary400"
                style={{ margin: '0 8px' }}
              >
                接案履歷
              </Typography>
              <Typography variant={mdDown ? 'h4' : 'h2'} color="black1000">
                開始！
              </Typography>
            </div>
            <SWAPSpace size={mdDown ? 8 : 16} />
            <Typography
              variant={mdDown ? 'body1_loose' : 'h5'}
              color="black700"
              style={{ fontWeight: 400 }}
            >
              SWAP 接案履歷，讓每個案主都驚艷於你的專業風采。
            </Typography>
            <SWAPSpace size={mdDown ? 24 : 40} />
            <div
              style={{
                display: 'flex',
                alignItems: mdDown ? 'flex-start' : 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: 40,
                  height: 40,
                  padding: 10,
                  marginRight: 8,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 8,
                  backgroundColor: '#E6E9F8',
                }}
              >
                {check_icon}
              </div>
              <Typography variant={'body2'} color="black700">
                在 SWAP
                平台上達成指定目標，如實名認證、請款等，增加業主信任，加速事業發展
              </Typography>
            </div>
            <SWAPSpace size={mdDown ? 8 : 24} />
            <div
              style={{
                display: 'flex',
                alignItems: mdDown ? 'flex-start' : 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: 40,
                  height: 40,
                  padding: 10,
                  marginRight: 8,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 8,
                  backgroundColor: '#FEF8E3',
                }}
              >
                {file_icon}
              </div>
              <Typography variant={'body2'} color="black700">
                輕鬆將作品、專案、社群、文章等內容整合在一個接案履歷上，讓訪客能夠快速瀏覽並了解你的專業水準。
              </Typography>
            </div>
            <SWAPSpace size={mdDown ? 8 : 24} />
            <div
              style={{
                display: 'flex',
                alignItems: mdDown ? 'flex-start' : 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: 40,
                  height: 40,
                  padding: 10,
                  marginRight: 8,
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 8,
                  backgroundColor: '#E6F6E8',
                }}
              >
                {member_icon}
              </div>
              <Typography variant={'body2'} color="black700">
                在 SWAP 平台上透過接案履歷報名社團內的案件
              </Typography>
            </div>
            <SWAPSpace size={mdDown ? 24 : 40} />
            <Button
              size={mdDown ? 'medium' : 'large'}
              style={{ width: mdDown ? '100%' : 240 }}
              onClick={handleButtonClick}
            >
              立即建立
            </Button>
          </div>
          <SWAPSpace size={smDown ? 24 : 40} />
          <Image
            src={
              'https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/resume.png'
            }
            layout="intrinsic"
            width={smDown ? 400 : mdDown ? 480 : 538}
            height={smDown ? 488 : mdDown ? 588 : 657}
            alt="resume image"
            loading="eager"
          />
        </div>
      </div>
      <SWAPSpace size={80} />
    </div>
  )
}

// 功能區域
enum FunctionType {
  QUOTATION = 'QUOTATION',
  REQUEST_PAYMENT = 'REQUEST_PAYMENT',
  INVOICE = 'INVOICE',
}
interface FunctionSwitchComponentProps {
  type: FunctionType
  setType: (type: FunctionType) => void
}
const FunctionSwitchComponent = ({
  type,
  setType,
}: FunctionSwitchComponentProps) => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down(961))

  // 做出開關動畫
  useEffect(() => {
    // 獲取所有的要改變的元素
    const quotationHeightEl = document.querySelector(
      `.${FunctionType.QUOTATION}-height`
    )
    const quotationOpacityEl = document.querySelector(
      `.${FunctionType.QUOTATION}-opacity`
    )
    const requestPaymentHeightEl = document.querySelector(
      `.${FunctionType.REQUEST_PAYMENT}-height`
    )
    const requestPaymentOpacityEl = document.querySelector(
      `.${FunctionType.REQUEST_PAYMENT}-opacity`
    )
    const invoiceHeightEl = document.querySelector(
      `.${FunctionType.INVOICE}-height`
    )
    const invoiceOpacityEl = document.querySelector(
      `.${FunctionType.INVOICE}-opacity`
    )

    // 有元素為 undefined 程序會崩潰，所以如果有元素沒抓到就跳出
    if (
      !quotationHeightEl ||
      !quotationOpacityEl ||
      !requestPaymentHeightEl ||
      !requestPaymentOpacityEl ||
      !invoiceHeightEl ||
      !invoiceOpacityEl
    )
      return

    // 清除所有元素上的 class
    quotationHeightEl!.classList.remove('active-height', 'hidden-height')
    requestPaymentHeightEl!.classList.remove('active-height', 'hidden-height')
    invoiceHeightEl!.classList.remove('active-height', 'hidden-height')
    quotationOpacityEl!.classList.remove('active-opacity', 'hidden-opacity')
    requestPaymentOpacityEl!.classList.remove(
      'active-opacity',
      'hidden-opacity'
    )
    invoiceOpacityEl!.classList.remove('active-opacity', 'hidden-opacity')

    /**
     *  針對性加上 class
     *  開啟時，文字要等待 200ms 後才改變透明度顯示
     */
    if (type === FunctionType.QUOTATION) {
      quotationHeightEl!.classList.add('active-height')
      setTimeout(() => {
        quotationOpacityEl!.classList.add('active-opacity')
      }, 200)
      requestPaymentHeightEl!.classList.add('hidden-height')
      requestPaymentOpacityEl!.classList.add('hidden-opacity')
      invoiceHeightEl!.classList.add('hidden-height')
      invoiceOpacityEl!.classList.add('hidden-opacity')
    }
    if (type === FunctionType.REQUEST_PAYMENT) {
      requestPaymentHeightEl!.classList.add('active-height')
      setTimeout(() => {
        requestPaymentOpacityEl!.classList.add('active-opacity')
      }, 200)
      quotationHeightEl!.classList.add('hidden-height')
      quotationOpacityEl!.classList.add('hidden-opacity')
      invoiceHeightEl!.classList.add('hidden-height')
      invoiceOpacityEl!.classList.add('hidden-opacity')
    }
    if (type === FunctionType.INVOICE) {
      invoiceHeightEl!.classList.add('active-height')
      setTimeout(() => {
        invoiceOpacityEl!.classList.add('active-opacity')
      }, 200)
      quotationHeightEl!.classList.add('hidden-height')
      quotationOpacityEl!.classList.add('hidden-opacity')
      requestPaymentHeightEl!.classList.add('hidden-height')
      requestPaymentOpacityEl!.classList.add('hidden-opacity')
    }
  }, [type])

  return (
    <>
      <style>
        {`
        .function-switch-component {
          .hidden-height {
            max-height: 0 !important;
            transition: max-height .3s linear;
          }
          .hidden-opacity {
            opacity: 0 !important;
            transition: opacity .1s linear;
          }
          .active-height {
            max-height: ${mdDown ? 112 : 88}px !important;
            transition: max-height .3s linear;
          }
          .active-opacity {
            opacity: 1 !important;
            transition: opacity .1s linear;
          }
        }
        `}
      </style>
      <div
        className="function-switch-component"
        style={{
          borderRadius: 24,
          border: '1px solid #ECECEC',
          background: '#ffffff'
        }}
      >
        <div
          style={{
            padding: '24px 16px 20px',
            borderBottom: '1px solid #ececec',
            cursor: 'pointer'
        }}
          onClick={() => setType(FunctionType.QUOTATION)}
        >
          <div style={{ width: '100%', display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 32,
                height: 32,
                borderRadius: 8,
                backgroundColor:
                  type === FunctionType.QUOTATION ? '#4862CC' : '#909090',
              }}
            >
              {paper_icon}
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flex: 1,
                margin: '0 16px',
              }}
            >
              <Typography variant={'title'} color="black1000">
                報價單
              </Typography>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 32,
                height: 32,
                cursor: 'pointer',
              }}
            >
              {type === FunctionType.QUOTATION
                ? arrow_up_icon
                : arrow_down_icon}
            </div>
          </div>
          <div
            className={`${FunctionType.QUOTATION}-height`}
            style={{ padding: '0 48px', overflow: 'hidden', maxHeight: 0 }}
          >
            <SWAPSpace size={8} />
            <div
              className={`${FunctionType.QUOTATION}-opacity`}
              style={{ opacity: 0 }}
            >
              <Typography variant={'body2_loose'} color="black800">
                由平台方協助開立報價單，滿足客戶要求報價與請款方需為同單位的需求。
              </Typography>
              <SWAPSpace size={12} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
                onClick={() =>
                  window.open(
                    'https://swap.work/q/e7ff2c56-9c6f-490d-a5c6-2c36d96392ef?access_code=tio6PHlIX0',
                    '_blank'
                  )
                }
              >
                {used_paper_primary_icon}
                <Typography
                  variant={'title'}
                  color="primary400"
                  style={{ marginLeft: 2 }}
                >
                  報價單範本
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            padding: '20px 16px',
            borderBottom: '1px solid #ececec',
            cursor: 'pointer'
        }}
          onClick={() => setType(FunctionType.REQUEST_PAYMENT)}
        >
          <div style={{ width: '100%', display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 32,
                height: 32,
                borderRadius: 8,
                backgroundColor:
                  type === FunctionType.REQUEST_PAYMENT ? '#4862CC' : '#909090',
              }}
            >
              {used_paper_icon}
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flex: 1,
                margin: '0 16px',
              }}
            >
              <Typography variant={'title'} color="black1000">
                請款單
              </Typography>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 32,
                height: 32,
                cursor: 'pointer',
              }}
            >
              {type === FunctionType.REQUEST_PAYMENT
                ? arrow_up_icon
                : arrow_down_icon}
            </div>
          </div>
          <div
            className={`${FunctionType.REQUEST_PAYMENT}-height`}
            style={{ padding: '0 48px', overflow: 'hidden', maxHeight: 0 }}
          >
            <SWAPSpace size={8} />
            <div
              className={`${FunctionType.REQUEST_PAYMENT}-opacity`}
              style={{ opacity: 0 }}
            >
              <Typography variant={'body2_loose'} color="black800">
                由平台協助雙方結算案件報酬，透過手機就能發送線上請款單，一手掌握請款進度。
              </Typography>
              <SWAPSpace size={12} />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    marginRight: 16,
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() =>
                    window.open(
                      'https://swap.work/i/f58a6482-bbaa-4910-bbdb-c874844bb90c?access_code=VEHpA4nagS',
                      '_blank'
                    )
                  }
                >
                  {used_paper_primary_icon}
                  <Typography
                    variant={'title'}
                    color="primary400"
                    style={{ marginLeft: 2 }}
                  >
                    請款單範本
                  </Typography>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() =>
                    window.open(
                      'https://swap.work/tools/payment?amt=10000',
                      '_blank'
                    )
                  }
                >
                  {paper_primary_icon}
                  <Typography
                    variant={'title'}
                    color="primary400"
                    style={{ marginLeft: 2 }}
                  >
                    請款單試算
                  </Typography>
                </div>
                <SWAPSpace size={8} />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ padding: '20px 16px 24px', cursor: 'pointer' }}
          onClick={() => setType(FunctionType.INVOICE)}
        >
          <div style={{ width: '100%', display: 'flex' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 32,
                height: 32,
                borderRadius: 8,
                backgroundColor:
                  type === FunctionType.INVOICE ? '#4862CC' : '#909090',
              }}
            >
              {used_paper_icon}
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flex: 1,
                margin: '0 16px',
              }}
            >
              <Typography variant={'title'} color="black1000">
                開立發票
              </Typography>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: 32,
                height: 32,
              }}
            >
              {type === FunctionType.INVOICE ? arrow_up_icon : arrow_down_icon}
            </div>
          </div>
          <div
            className={`${FunctionType.INVOICE}-height`}
            style={{ padding: '0 48px', overflow: 'hidden', maxHeight: 0 }}
          >
            <SWAPSpace size={8} />
            <div
              className={`${FunctionType.INVOICE}-opacity`}
              style={{ opacity: 0 }}
            >
              <Typography variant={'body2_loose'} color="black800">
                客戶付款後，平台即時開立電子發票，滿足公司端發票核銷的需求。
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
const FunctionsComponent = () => {
  const theme = useTheme()
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'))
  const mdDown = useMediaQuery(theme.breakpoints.down(961))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const imageQuotationUrl =
    'https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/quotation.png'
  const imageRequestPaymentUrl =
    'https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/request_payment.png'
  const imageInvoiceUrl =
    'https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/invoice.png'
  const [type, setType] = useState(FunctionType.QUOTATION)
  const [imageUrl, setImageUrl] = useState(imageQuotationUrl)

  useEffect(() => {
    if (type === FunctionType.QUOTATION) {
      setImageUrl(imageQuotationUrl)
    }
    if (type === FunctionType.REQUEST_PAYMENT) {
      setImageUrl(imageRequestPaymentUrl)
    }
    if (type === FunctionType.INVOICE) {
      setImageUrl(imageInvoiceUrl)
    }
  }, [type])

  return (
    <div>
      <SWAPSpace size={mdDown ? 0 : 120} />
      <div className="swap-container">
        {mdDown ? (
          <div>
            <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
              <Typography variant={'h4'} color="primary400" style={{ marginRight: 8 }}>
                個人接案
              </Typography>
              <Typography variant={'h4'} color="black1000">
                輕鬆對接客戶公司
              </Typography>
            </div>
            <SWAPSpace size={8}/>
            <Typography variant={'body1_loose'} color="black700" style={{ fontWeight: 400 }}>
              使用 SWAP 平台開立帳務文件，結算案件報酬
            </Typography>
            <SWAPSpace size={smDown ? 24 : 40} />
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  backgroundColor: '#4862CC',
                }}
              >
                {paper_icon}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                  margin: '0 8px',
                }}
              >
                <Typography variant={'title'} color="black1000">
                  報價單
                </Typography>
              </div>
            </div>
            <SWAPSpace size={8} />
            <div style={{ padding: '0 40px' }}>
              <Typography variant={'body2_loose'} color="black800">
                由平台方協助開立報價單，滿足客戶要求報價與請款方需為同單位的需求。
              </Typography>
              <SWAPSpace size={4} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  window.open(
                    'https://swap.work/q/e7ff2c56-9c6f-490d-a5c6-2c36d96392ef?access_code=tio6PHlIX0',
                    '_blank'
                  )
                }
              >
                {used_paper_primary_mobile_icon}
                <Typography
                  variant={'subtitle'}
                  color="primary400"
                  style={{ marginLeft: 2 }}
                >
                  報價單範本
                </Typography>
              </div>
            </div>
            <SWAPSpace size={smDown ? 24 : 40} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0 4px',
              }}
            >
              <Image
                src={imageQuotationUrl}
                layout="intrinsic"
                width={smDown ? 400 : 480}
                height={smDown ? 498 : 598}
                objectFit="contain"
                alt="function images"
                loading="eager"
              />
            </div>
            <SWAPSpace size={smDown ? 24 : 40} />
            <div style={{ display: 'flex' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  backgroundColor: '#4862CC',
                }}
              >
                {paper_icon}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                  margin: '0 8px',
                }}
              >
                <Typography variant={'title'} color="black1000">
                  請款單
                </Typography>
              </div>
            </div>
            <SWAPSpace size={8} />
            <div style={{ padding: '0 40px' }}>
              <Typography variant={'body2_loose'} color="black800">
                由平台協助雙方結算案件報酬，透過手機就能發送線上請款單，一手掌握請款進度。
              </Typography>
              <SWAPSpace size={4} />
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    marginRight: 16,
                  }}
                  onClick={() =>
                    window.open(
                      'https://swap.work/i/f58a6482-bbaa-4910-bbdb-c874844bb90c?access_code=VEHpA4nagS',
                      '_blank'
                    )
                  }
                >
                  {used_paper_primary_mobile_icon}
                  <Typography
                    variant={'subtitle'}
                    color="primary400"
                    style={{ marginLeft: 2 }}
                  >
                    請款單範本
                  </Typography>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    window.open(
                      'https://swap.work/tools/payment?amt=10000',
                      '_blank'
                    )
                  }
                >
                  {paper_primary_mobile_icon}
                  <Typography
                    variant={'subtitle'}
                    color="primary400"
                    style={{ marginLeft: 2 }}
                  >
                    請款單試算
                  </Typography>
                </div>
                <SWAPSpace size={8} />
              </div>
            </div>
            <SWAPSpace size={smDown ? 24 : 40} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0 4px',
              }}
            >
              <Image
                src={imageRequestPaymentUrl}
                layout="intrinsic"
                width={smDown ? 400 : 480}
                height={smDown ? 498 : 598}
                objectFit="contain"
                alt="function images"
                loading="eager"
              />
            </div>
            <SWAPSpace size={smDown ? 24 : 40} />

            <div style={{ display: 'flex' }}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  backgroundColor: '#4862CC',
                }}
              >
                {paper_icon}
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flex: 1,
                  margin: '0 8px',
                }}
              >
                <Typography variant={'title'} color="black1000">
                  開立發票
                </Typography>
              </div>
            </div>
            <SWAPSpace size={8} />
            <div style={{ padding: '0 40px' }}>
              <Typography variant={'body2_loose'} color="black800">
                客戶付款後，平台即時開立電子發票，滿足公司端發票核銷的需求。
              </Typography>
            </div>
            <SWAPSpace size={smDown ? 24 : 40} />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '0 4px',
              }}
            >
              <Image
                src={imageInvoiceUrl}
                layout="intrinsic"
                width={smDown ? 400 : 480}
                height={smDown ? 498 : 598}
                objectFit="contain"
                alt="function images"
                loading="eager"
              />
            </div>
            <SWAPSpace size={smDown ? 24 : 40} />
            <Button
              size="medium"
              style={{ width: '100%' }}
              onClick={() =>
                (window.location.href = 'https://swap.work/functions/invoice')
              }
            >
              了解詳細內容
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div style={{ marginRight: 100 }}>
              <Image
                src={imageUrl}
                layout="intrinsic"
                width={lgDown ? 480 : 538}
                height={lgDown ? 588 : 657}
                objectFit="contain"
                alt="function images"
                loading="eager"
              />
            </div>
            <div style={{ width: 420 }}>
              <div style={{ display: 'flex', whiteSpace: 'nowrap' }}>
                <Typography variant={'h2'} color="primary400" style={{ marginRight: 8 }}>
                  個人接案
                </Typography>
                <Typography variant={'h2'} color="black1000">
                  輕鬆對接客戶公司
                </Typography>
              </div>
              <SWAPSpace size={16}/>
              <Typography variant={'h5'} color="black700" style={{ fontWeight: 400 }}>
                使用 SWAP 平台開立帳務文件，結算案件報酬
              </Typography>
              <SWAPSpace size={40} />
              <FunctionSwitchComponent type={type} setType={setType} />
              <SWAPSpace size={40} />
              <Button
                size="large"
                style={{
                  width: 240,
                }}
                onClick={() =>
                  (window.location.href = 'https://swap.work/functions/invoice')
                }
              >
                了解詳細內容
              </Button>
            </div>
          </div>
        )}
      </div>
      <SWAPSpace size={smDown ? 64 : 136} />
    </div>
  )
}

// 進度區塊
interface ProcessCardProps {
  index: number
  content: string
  label: string
}
const ProcessesCardData: ProcessCardProps[] = [
  {
    index: 0,
    content: '會員主動媒合客戶，SWAP 平台加速雙方合作效率',
    label: '已開放'
  },
  {
    index: 1,
    content: '會員有機與 SWAP 官方合作，參與活動',
    label: '封測中'
  },
  {
    index: 2,
    content: '臉書, LINE... 等接發案社群的合作機會',
    label: '內部測試中'
  },
  {
    index: 3,
    content: '接發案媒合平台, App 的合作機會',
    label: '內部測試中'
  },
  {
    index: 4,
    content: '發案類型公司的合作機會',
    label: '規劃中'
  },
  {
    index: 5,
    content: '中小企業的合作機會',
    label: '規劃中'
  },
  {
    index: 6,
    content: '個人業主的合作機會',
    label: '規劃中'
  },
]
const ProcessCard = ({ index, content, label }: ProcessCardProps) => {
  const labelType =
    label === '內部測試中' || label === '規劃中' ? 'neutral' : 'success'
  const direction = index % 2 === 0 ? 'up' : 'down'

  return (
    <div
      style={{
        scrollSnapAlign: 'start',
        minWidth: 228,
        width: 228,
        height: 130,
        padding: 24,
        marginRight: 24,
        borderRadius: 12,
        border: '1px solid white',
        transform: `translateY(${direction === 'down' ? '-' : '+'}20px)`,
        background:
          index === 0
            ? '#6C7FD5'
            : index === 1
            ? 'radial-gradient(109.58% 150.29% at 24.58% 31.71%, #6C7FD5 27%, #B68FE8 53.26%, #E8B6DD 66.5%, #FBDF8A 79.86%)'
            : '#F9F9F9',
        boxShadow:
          index == 0 ? '0px 8px 40px 0px rgba(0, 0, 0, 0.12)' : 'unset',
      }}
    >
      <div
        style={{
          height: 34,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography
          variant={'h5'}
          color={index === 0 || index === 1 ? 'white' : 'black1000'}
        >
          {'0' + (index + 1)}
        </Typography>
        <Chip contained label={label} variant={labelType} />
      </div>
      <SWAPSpace size={8} />
      <Typography
        variant={index === 0 || index === 1 ? 'subtitle' : 'body2'}
        color={index === 0 || index === 1 ? 'white' : 'black700'}
      >
        {content}
      </Typography>
    </div>
  )
}

const Draggable = ({
  rootClass = '',
  children,
  style,
}: {
  rootClass: string
  children: any
  style: any
}) => {
  const ourRef = useRef(null)
  const [isMouseDown, setIsMouseDown] = useState(false)
  const mouseCoords = useRef({
    startX: 0,
    startY: 0,
    scrollLeft: 0,
    scrollTop: 0,
  })
  const handleDragStart = (e: any) => {
    if (!ourRef.current) return
    const slider = (ourRef.current as any).children[0]
    const startX = e.pageX - slider.offsetLeft
    const startY = e.pageY - slider.offsetTop
    const scrollLeft = slider.scrollLeft
    const scrollTop = slider.scrollTop
    mouseCoords.current = { startX, startY, scrollLeft, scrollTop }
    setIsMouseDown(true)
    document.body.style.cursor = 'grabbing'
  }
  const handleDragEnd = () => {
    setIsMouseDown(false)
    if (!ourRef.current) return
    document.body.style.cursor = 'default'
  }
  const handleDrag = (e: any) => {
    if (!isMouseDown || !ourRef.current) return
    e.preventDefault()
    const slider = (ourRef.current as any).children[0]
    const x = e.pageX - slider.offsetLeft
    const y = e.pageY - slider.offsetTop
    const walkX = (x - mouseCoords.current.startX) * 1.5
    const walkY = (y - mouseCoords.current.startY) * 1.5
    slider.scrollLeft = mouseCoords.current.scrollLeft - walkX
    slider.scrollTop = mouseCoords.current.scrollTop - walkY
  }

  return (
    <div
      ref={ourRef}
      onMouseDown={handleDragStart}
      onMouseUp={handleDragEnd}
      onMouseMove={handleDrag}
      className={rootClass + 'flex overflow-x-scroll'}
      style={style}
    >
      {children}
    </div>
  )
}

const ProcessesComponent = () => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down(961))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const refContainer = useRef(null)

  return (
    <div>
      {/* 上波浪圖 */}
      <div
        style={{
          width: '100%',
          height: 56,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundImage: `url('https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/wave_top.png')`,
          transform: 'translateY(2px)',
        }}
      />
      <div style={{ backgroundColor }}>
        <SWAPSpace size={smDown ? 40 : 120} />
        <div className="swap-container">
          <Typography variant={smDown ? 'h4' : 'h1'} color="black1000">
            一個渠道，媒合多元案源
          </Typography>
          <SWAPSpace size={smDown ? 8 : mdDown ? 12 : 16} />
          <Typography
            variant={smDown ? 'body1_loose' : 'h5'}
            color="black700"
            style={{ fontWeight: 400 }}
          >
            SWAP 案源媒合網路，透過平台連結 SOHO 與業主，持續延伸發展中
          </Typography>
          <Draggable
            rootClass={'drag'}
            style={{ width: `calc(100% + ${smDown ? 24 : 100}px)` }}
          >
            <div
              style={{
                display: 'flex',
                overflowX: 'auto',
                padding: smDown ? '44px 0 60px' : '60px 0 100px',
              }}
              ref={refContainer}
            >
              {ProcessesCardData.map((card) => (
                <ProcessCard key={card.index} {...card} />
              ))}
            </div>
          </Draggable>
        </div>
      </div>
    </div>
  )
}
// 社團區塊
const GroupComponent = ({
  setAuthModal,
}: {
  setAuthModal: (show: boolean) => void
}) => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const SWAPGroupId = '2251014c-391e-42e7-91d8-fdc6b3cdce73'
  // const [swiper, setSwiper] = useState(undefined)
  // const [isLogin, setIsLogin] = useState(false)
  const [member, setMember] = useState({ id: '' })
  const [groupList, setGroupList] = useState<GroupItem[]>([])
  const [isJoinedSWAPGroup, setIsJoinedSWAPGroup] = useState<boolean>(false)
  const [newsItems, setNewsItems] = useState<NewsItem[]>([])
  const [isOpenJoinModal, setIsOpenJoinModal] = useState(false)
  const [isOpenApplyModal, setIsOpenApplyModal] = useState(false)
  const [isOpenJoinGroupSnackbar, setIsOpenJoinGroupSnackbar] = useState(false)
  const [isOpenApplyCaseSnackbar, setIsOpenApplyCaseSnackbar] = useState(false)
  const [selectedCaseId, setSelectedCaseId] = useState('')
  const [selectedRoles, setSelectedRoles] = useState<CGIR[]>([])

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    // 目前的邏輯，有加入 SWAP 就當作有將入社團
    setIsJoinedSWAPGroup(!!groupList.length)
  }, [groupList])

  const init = async () => {
    await handleGetMember()
    await handleGetJoinedCaseGroupsFromSOHO()
    await handleGetCaseGroupItemsFromSOHO()
  }
  const handleGetMember = async () => {
    try {
      GetMember(`payload{
        member {
          id
        }
      }`).then((r: any) => {
        if (r) {
          setMember(r.payload.member)
        }
      })
    } catch (err) {
      console.log('查詢會員料時發生錯誤，請聯繫客服')
    }
  }

  // 取得已經加入的社團列表
  const handleGetJoinedCaseGroupsFromSOHO = async () => {
    try {
      const GetJoinedCaseGroupsFromSOHOResult: any =
        await GetJoinedCaseGroupsFromSOHO()
      if (
        GetJoinedCaseGroupsFromSOHOResult &&
        GetJoinedCaseGroupsFromSOHOResult.errors === null
      ) {
        const data = GetJoinedCaseGroupsFromSOHOResult.payload
        setGroupList(data)
      }
    } catch (err) {
      console.log('查詢帳號資料時發生錯誤，請聯繫客服')
    }
  }

  const handleGetCaseGroupItemsFromSOHO = async () => {
    try {
      const GetCaseGroupItemsFromSOHOResult: any =
        await GetCaseGroupItemsFromSOHO()
      if (
        GetCaseGroupItemsFromSOHOResult &&
        GetCaseGroupItemsFromSOHOResult.errors === null
      ) {
        // 目前只有 SWAP 一個社團，任務不做 filter
        const data = GetCaseGroupItemsFromSOHOResult.payload
        setNewsItems(data)
      }
    } catch (err) {
      console.log('查詢所有接案資料時發生錯誤，請聯繫客服')
    }
  }

  const handleLinkGroup = () => {
    if (!ParseAccountToken()) {
      window.open(`/public/group/${SWAPGroupId}`, '_blank')
    } else {
      window.open(`/member/group/detail/${SWAPGroupId}`, '_blank')
    }
  }
  const handleJoinGroup = () => {
    if (!ParseAccountToken()) {
      setAuthModal(true)
      return
    }
    setIsOpenJoinModal(true)
  }

  const setNews = (item: NewsItem) => {
    setSelectedCaseId(item.id)
    // 可申請加入的中，已經招募完畢的不顯示
    const _filterCgir = item.cgir.filter(
      (cgir: CGIR) => cgir.cgirm.length < +cgir.quantity_required
    )
    setSelectedRoles(_filterCgir)
  }

  return (
    <div style={{ backgroundColor }}>
      <div className="swap-container">
        <Typography variant={smDown ? 'h4' : 'h2'} color="black1000">
          SWAP 官方社團合作案
        </Typography>
        <SWAPSpace size={smDown ? 8 : mdDown ? 12 : 16} />
        <Typography
          variant={smDown ? 'body1_loose' : 'h5'}
          color="black700"
          style={{ fontWeight: 400 }}
        >
          加入社團，即可報名社團內的各種案件與活動
        </Typography>
        <SWAPSpace size={smDown ? 24 : 40} />
        <div
          style={{
            position: 'relative',
            height: 0,
            width: '100%',
            paddingBottom: '25%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundImage: `url('https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/cover.png')`,
            border: '2px solid white',
            borderRadius: 12,
            boxShadow: '0px 8px 40px 0px rgba(0, 0, 0, 0.12)',
          }}
        >
          {smDown ? null : (
            <div
              style={{
                position: 'absolute',
                top: 16,
                right: 16,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                variant="secondary"
                size="large"
                onClick={handleLinkGroup}
                style={{
                  marginRight: 8,
                }}
              >
                查看社團
              </Button>
              {isJoinedSWAPGroup ? (
                <Button variant="secondary" size="large" disabled>
                  已加入
                </Button>
              ) : (
                <Button
                  variant="primary"
                  size="large"
                  onClick={handleJoinGroup}
                >
                  立即加入
                </Button>
              )}
            </div>
          )}
        </div>
        <SWAPSpace size={smDown ? 16 : 24} />
        {smDown ? (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                variant="secondary"
                size="small"
                onClick={handleLinkGroup}
                style={{
                  width: '50%',
                  marginRight: 8,
                }}
              >
                查看社團
              </Button>
              {isJoinedSWAPGroup ? (
                <Button
                  variant="secondary"
                  size="small"
                  disabled
                  style={{
                    width: '50%',
                  }}
                >
                  已加入
                </Button>
              ) : (
                <Button
                  variant="primary"
                  size="small"
                  onClick={handleJoinGroup}
                  style={{
                    width: '50%',
                  }}
                >
                  立即加入
                </Button>
              )}
            </div>
            <SWAPSpace size={16} />
          </>
        ) : null}
        <div className="group-container">
          <MySlider slidesToShow={smDown ? 1 : 2}>
            {newsItems.map((item: NewsItem) => {
              return (
                <div key={`group-${item.id}`}>
                  <CaseCard
                    key={item.id}
                    data={item}
                    style={{ margin: 0, width: '100%' }}
                    member={member}
                    isJoined={isJoinedSWAPGroup}
                    homePageCard
                    onOpenApplyModal={() => {
                      if (!ParseAccountToken()) {
                        setAuthModal(true)
                        return
                      }
                      setNews(item)
                      setIsOpenApplyModal(true)
                    }}
                    onOpenJoinModal={() => {
                      if (!ParseAccountToken()) {
                        setAuthModal(true)
                        return
                      }
                      setNews(item)
                      setIsOpenJoinModal(true)
                    }}
                    onOpenShareModal={() => {}}
                  />
                </div>
              )
            })}
          </MySlider>
        </div>
      </div>
      <SWAPSpace size={smDown ? 80 : 104} />
      <div
        style={{
          width: '100%',
          height: 56,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundImage: `url('https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/wave_bottom.png')`,
          transform: 'translateY(2px)',
        }}
      />

      {/* Modal */}
      <JoinModal
        groupId={SWAPGroupId}
        open={isOpenJoinModal}
        onSuccess={() => {
          setIsOpenJoinModal(false)
          setIsOpenJoinGroupSnackbar(true)
          window.location.reload()
        }}
        onClose={() => setIsOpenJoinModal(false)}
      />
      <ApplyModal
        caseId={selectedCaseId}
        roles={selectedRoles}
        open={isOpenApplyModal}
        onSuccess={() => setIsOpenApplyCaseSnackbar(true)}
        onClose={() => setIsOpenApplyModal(false)}
      />
      <Snackbar
        open={isOpenJoinGroupSnackbar}
        icon={icon_success_white}
        onClose={() => setIsOpenJoinGroupSnackbar(false)}
        width="100%"
        variant="success"
        autoHideDuration={5000}
        transitionDirection="up"
        transitionDuration={{ enter: 500, exit: 500 }}
        message="已成功加入 SWAP 官方社團！"
        action={
          <div
            style={{ cursor: 'pointer', marginRight: 12 }}
            onClick={() => setIsOpenJoinGroupSnackbar(false)}
          >
            {icon_close_white}
          </div>
        }
      />
      {/*<Snackbar*/}
      {/*  open={isOpenLeaveGroupSnackbar}*/}
      {/*  icon={icon_success_white}*/}
      {/*  onClose={() => setIsOpenLeaveGroupSnackbar(false)}*/}
      {/*  width="100%"*/}
      {/*  autoHideDuration={5000}*/}
      {/*  transitionDirection="up"*/}
      {/*  transitionDuration={{ enter: 500, exit: 500 }}*/}
      {/*  message="已成功退出社團！"*/}
      {/*  action={*/}
      {/*    <div*/}
      {/*      style={{ cursor: "pointer", marginRight: 12 }}*/}
      {/*      onClick={() => setIsOpenLeaveGroupSnackbar(false)}*/}
      {/*    >*/}
      {/*      {icon_close_white}*/}
      {/*    </div>*/}
      {/*  }*/}
      {/*/>*/}
      <Snackbar
        open={isOpenApplyCaseSnackbar}
        icon={icon_success_white}
        onClose={() => setIsOpenApplyCaseSnackbar(false)}
        width="100%"
        variant="success"
        autoHideDuration={5000}
        transitionDirection="up"
        transitionDuration={{ enter: 500, exit: 500 }}
        message="您已成功報名任務！"
        action={
          <div
            style={{ cursor: 'pointer', marginRight: 12 }}
            onClick={() => setIsOpenApplyCaseSnackbar(false)}
          >
            {icon_close_white}
          </div>
        }
      />
    </div>
  )
}

// 訪談區塊
const InterviewComponent = () => {
  const theme = useTheme()
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'))
  // const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const [statistics, setStatistics] = useState({
    total_enterprises: 0,
    total_income: 0,
    total_members: 0,
  })
  const [statisticsStart, setStatisticsStart] = useState(false)
  const [interviews, setInterviews] = useState<any[]>([])
  const [groupInterviews, setGroupInterviews] = useState<any[][]>([])

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    const groupData = () => {
      const SPLIT_NUMBER = smDown ? 2 : lgDown ? 4 : 6
      const _groupByInterviews = interviews.reduce(
        (ary: any[], item: any, index: number) => {
          if (index % SPLIT_NUMBER === 0) {
            ary.push([item])
          } else {
            ary[ary.length - 1].push(item)
          }
          return ary
        },
        []
      )
      setGroupInterviews(_groupByInterviews)
    }
    groupData()
  }, [lgDown, smDown, interviews])

  const init = async () => {
    await handleGetStatisticsFromGuess()
    await handleGetWordpressInterviews()
    setCountUpObserver()
  }

  const handleGetStatisticsFromGuess = async () => {
    try {
      const GetStatisticsFromGuessResult: any = await GetStatisticsFromGuess()
      if (
        GetStatisticsFromGuessResult &&
        GetStatisticsFromGuessResult.errors === null
      ) {
        const data = GetStatisticsFromGuessResult.payload
        setStatistics(data)
      }
    } catch (err) {
      console.log('查詢所有接案資料時發生錯誤，請聯繫客服')
    }
  }

  const handleGetWordpressInterviews = async () => {
    try {
      const result = await axios.get(
        'https://blog.swap.work/wp-json/wp/v2/posts?categories=22'
      )
      if (result && result.status === 200) {
        if (result.data.length) {
          setInterviews(result.data)
        }
      }
    } catch (err) {
      console.error(err)
    }
  }

  const setCountUpObserver = () => {
    const el = document.querySelector(`#statistics-card`)
    if (!el) return

    /*
     * 統計資料卡片顯示在畫面上時，啟動數字跳動動畫 (CountUp)
     * threshold 為 0.5，表示當元素顯示在畫面中超過 50% 時，觸發事件
     */
    const triggerEvent = (
      entries: IntersectionObserverEntry[],
      observer: IntersectionObserver
    ) => {
      entries.forEach(async (item: IntersectionObserverEntry) => {
        if (item.isIntersecting) {
          // 移除監聽
          observer.unobserve(el!)
          // 呼叫統計 API
          setStatisticsStart(true)
        }
      })
    }
    const ob = new IntersectionObserver(triggerEvent, { threshold: 0.5 })
    if (el) {
      // 監聽元素
      ob.observe(el)
    }
  }

  // 獲得專訪資料
  const InterviewCard = ({ item, slidesToShow = 1 }: {item: any, slidesToShow?: number}) => (
    <Link
      href={item.link}
      style={{
        width: `calc(100% / ${slidesToShow} - 24px)`,
        margin: smDown ? 8 : 12,
        textDecoration: 'none'
      }}
    >
    <Paper
      className="interview-card"
      height="auto"
      style={{
        border: '2px solid #ffffff',
        background: '#f9f9f9',
        padding: '24px 32px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        boxSizing: 'border-box'
      }}
    >
        {/* Avatar */}
        <div
          className="avatar"
          style={{
            width: 88,
            height: 88,
            minWidth: 88,
            border: '2px solid #ffffff',
            borderRadius: '50%',
            boxShadow: '0px 8px 40px 0px rgba(0, 0, 0, 0.12)',
            overflow: 'hidden'
          }}>
          <Image
            src={item.acf.swap_member_avatar}
            objectPosition="top"
            width={88}
            height={88}
            alt="user image"
            placeholder="empty"
            objectFit="cover"
          />
        </div>

        <div style={{
          marginLeft: 16,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start'
        }}>
          <Typography variant={'body2'} color="black700">
            {item.title.rendered.split('：')[0]}
          </Typography>
          <SWAPSpace size={4} />
          <Typography
            variant={'title'}
            color="black1000"
            style={{
              height: 45,
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
            {item.title.rendered.split('：')[1]}
          </Typography>
        </div>
    </Paper>
    </Link>
  )

  return (
    <div style={{ backgroundColor: backgroundColorGray }}>
      <SWAPSpace size={smDown ? 0 : 80} />
      <div className="swap-container" style={{ position: 'relative' }}>
        <Typography variant={'h1'} color="black1000">
          SWAP 正在崛起
        </Typography>
        <SWAPSpace size={16} />
        <Typography variant={'h5'} color="black700" style={{ fontWeight: 400 }}>
          案源媒合網路，連結SWAP平台
        </Typography>
        <div
          style={{
            position: 'absolute',
            top: smDown ? 104 : 66,
            left: smDown ? 24 : 100,
            right: smDown ? 24 : 100,
            zIndex: 0,
          }}
        >
          <Image
            src={
              'https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/interview_bg.png'
            }
            width={1240}
            height={507}
          />
        </div>
        <SWAPSpace size={200} />
        <div
          id="statistics-card"
          style={{
            display: 'flex',
            flexDirection: smDown ? 'column' : 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
            zIndex: 2,
            margin: smDown ? '0' : '0 -12px',
          }}
        >
          <div
            style={{
              margin: smDown ? '0 0 16px 0' : '0 12px',
              width: smDown ? '100%' : 'calc(33.333% - 24px)',
            }}
          >
            <Card
              style={{ border: '2px solid #ffffff' }}
              bodyStyle={{
                padding: smDown ? 24 : '48px 24px',
                background: '#F9F9F9',
              }}
              width="100%"
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography variant={smDown ? 'h4' : 'h2'} color="primary400">
                  <CountUp
                    duration={2}
                    end={statisticsStart ? statistics.total_members : 0}
                    separator=","
                    suffix="+"
                    delay={0}
                  />
                </Typography>
                <SWAPSpace size={4} />
                <Typography
                  variant={smDown ? 'subtitle' : 'title'}
                  style={{ color: '#6f6f6f' }}
                >
                  會員數
                </Typography>
              </div>
            </Card>
          </div>
          <div
            style={{
              margin: smDown ? '0 0 16px 0' : '0 12px',
              width: smDown ? '100%' : 'calc(33.333% - 24px)',
            }}
          >
            <Card
              style={{ border: '2px solid #ffffff' }}
              bodyStyle={{
                padding: smDown ? 24 : '48px 24px',
                background: '#F9F9F9',
              }}
              width="100%"
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography variant={smDown ? 'h4' : 'h2'} color="primary400">
                  <CountUp
                    duration={2}
                    end={statisticsStart ? statistics.total_enterprises : 0}
                    separator=","
                    suffix="+"
                    delay={0}
                  />
                </Typography>
                <SWAPSpace size={4} />
                <Typography
                  variant={smDown ? 'subtitle' : 'title'}
                  style={{ color: '#6f6f6f' }}
                >
                  合作企業數
                </Typography>
              </div>
            </Card>
          </div>
          <div
            style={{
              margin: smDown ? '0 0 16px 0' : '0 12px',
              width: smDown ? '100%' : 'calc(33.333% - 24px)',
            }}
          >
            <Card
              style={{ border: '2px solid #ffffff' }}
              bodyStyle={{
                padding: smDown ? 24 : '48px 24px',
                background: '#F9F9F9',
              }}
              width="100%"
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Typography variant={smDown ? 'h4' : 'h2'} color="primary400">
                  <CountUp
                    duration={2}
                    end={statisticsStart ? statistics.total_income : 0}
                    separator=","
                    suffix="+"
                    delay={0}
                  />
                </Typography>
                <SWAPSpace size={4} />
                <Typography
                  variant={smDown ? 'subtitle' : 'title'}
                  style={{ color: '#6f6f6f' }}
                >
                  交易額
                </Typography>
              </div>
            </Card>
          </div>
        </div>
        <SWAPSpace size={smDown ? 24 : 80} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            position: 'relative',
            zIndex: 2,
          }}
        >
          <Typography variant={smDown ? 'h4' : 'h2'} color="black1000">
            自由工作者專訪
          </Typography>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() =>
              (window.location.href =
                'https://blog.swap.work/category/interview/')
            }
          >
            <Typography
              variant={'title'}
              color="primary400"
              style={{ marginRight: 2 }}
            >
              查看更多
            </Typography>
            {arrow_right_blue_icon}
          </div>
        </div>
        <SWAPSpace size={smDown ? 16 : 28} />
        <div className="interview-container">
          <MySlider>
            {groupInterviews.map((items: any[][], index: number) => {
              return (
                <div
                  key={`interviews-${index}`}
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    margin: smDown ? '0 -8px' : '0 -12px',
                  }}
                >
                  {items.map((item: any, index: number) => (
                    <InterviewCard
                      key={index}
                      item={item}
                      slidesToShow={smDown ? 1 : lgDown ? 2 : 3}
                    />
                  ))}
                </div>
              )
            })}
          </MySlider>
        </div>
        <SWAPSpace size={smDown ? 72 : 68} />
      </div>
    </div>
  )
}

// 自由工作者區
const FreelanceComponent = () => {
  const theme = useTheme()
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const [posts, setPosts] = useState<any[]>([])
  const [statistics, setStatistics] = useState({
    total_enterprises: 0,
    total_income: 0,
    total_members: 0
  })

  const init = async () => {
    new Swiper(".swiper-container-interview", {
      slidesPerView: 3,
      spaceBetween: 24,
      speed: 300,
      autoHeight: true,
      loop: false,
      effect: 'slide',
    })
    await handleGetStatisticsFromGuess()
  }

  const handleGetStatisticsFromGuess = async () => {
    try {
      const GetStatisticsFromGuessResult: any = await GetStatisticsFromGuess()
      if (GetStatisticsFromGuessResult && GetStatisticsFromGuessResult.errors === null) {
        const data = GetStatisticsFromGuessResult.payload
        setStatistics(data)
      }
    } catch (err) {
      console.log("查詢所有接案資料時發生錯誤，請聯繫客服");
    }
  }

  // 獲得路落格貼文功能
  const handleGetWordpressPosts = async () => {
    try {
      const result = await axios.get(
        'https://blog.swap.work/wp-json/wp/v2/posts?categories=21'
      )
      if (result && result.status === 200) {
        if (result.data.length) {
          setPosts(result.data)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    handleGetWordpressPosts()
  }, [])

  // @ts-ignore
  return (
    <div>
      <SWAPSpace size={smDown ? 40 : 120} />
      <div className="swap-container" style={{ position: 'relative' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Typography variant={smDown ? 'h4' : 'h1'} color="black1000">
            超過
          </Typography>
          <Typography variant={smDown ? 'h4' : 'h1'} color="primary400">
            { statistics.total_members }+
          </Typography>
          <Typography variant={smDown ? 'h4' : 'h1'} color="black1000">
            位自由工作者已經加入
          </Typography>
        </div>
        <SWAPSpace size={smDown ? 8 : 16} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            variant={smDown ? 'body1_loose' : 'h4'}
            color="black800"
            style={{ fontWeight: 400 }}
          >
            聽聽他們使用後的分享
          </Typography>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            position: 'absolute',
            top: smDown ? 133 : 140,
            left: smDown ? 0 : 24,
            right: smDown ? 0 : 24,
            zIndex: 0,
          }}
        >
          <Image
            src={
              'https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/freelance_bg.png'
            }
            width={1152}
            height={375}
          />
        </div>
        <SWAPSpace size={smDown ? 120 : 200} />
        <div className="freelance-container">
          <Slider
            {...{
              infinite: true,
              autoplay: true,
              autoplaySpeed: 1500,
              pauseOnHover: false,
              touchMove: false,
              slidesToShow: smDown ? 1 : mdDown ? 2 : 3,
              slidesToScroll: 1,
              arrows: false,
            }}
          >
            {testimonialData.map((item: any, index: number) => {
              return (
                <div key={`profile-${index}`}>
                  {/* Freelance 卡片 */}
                  <Paper height="auto" style={{
                    padding: 24,
                    position: 'relative',
                    border: 'unset'
                  }}>
                    {/* Avatar */}
                    <div
                      style={{
                        width: smDown ? 80 : 120,
                        height: smDown ? 80 : 120,
                        borderRadius: '50%',
                        border: '6px solid #ffffff',
                        overflow: 'hidden',
                        position: 'absolute',
                        top: 0,
                        left: '50%',
                        zIndex: 9,
                        transform: 'translate(-50%, -32px)',
                      }}
                    >
                      <Image
                        src={item.imgUrl}
                        objectPosition="top"
                        width={smDown ? 80 : 120}
                        height={smDown ? 80 : 120}
                        alt={item.imgAlt}
                        placeholder="empty"
                        objectFit="cover"
                      />
                    </div>
                    <div
                      style={{
                        width: smDown ? 48 : 80,
                        height: smDown ? 48 : 80,
                        position: 'absolute',
                        left: 10,
                        top: 10,
                      }}
                    >
                      {smDown
                        ? double_quotation_mobile_icon
                        : double_quotation_icon}
                    </div>
                    <SWAPSpace size={smDown ? 36 : 72} />
                    <Typography
                      variant={smDown ? 'title' : 'h4'}
                      color="black1000"
                      style={{ textAlign: 'center' }}
                    >
                      {item.name}
                    </Typography>
                    <SWAPSpace size={3} />
                    <Typography
                      variant={smDown ? 'caption1' : 'subtitle'}
                      color="primary400"
                      style={{ textAlign: 'center' }}
                    >
                      {item.profession}
                    </Typography>
                    <SWAPSpace size={3} />
                    <SWAPSpace size={smDown ? 5 : 12} />
                    <Typography
                      variant="body2_loose"
                      color="black700"
                      style={{ textAlign: 'center' }}
                    >
                      {item.comment}
                    </Typography>
                  </Paper>
                  <SWAPSpace size={40} />
                </div>
              )
            })}
          </Slider>
        </div>

        <SWAPSpace size={smDown ? 40 : 80} />
        <Typography variant={smDown ? 'h5' : 'h2'} color="black1000">
          共享知識，更了解自由工作者
        </Typography>
        <SWAPSpace size={12} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            position: 'relative',
            zIndex: 2,
          }}
        >
          <Typography
            variant={smDown ? 'body1_loose' : 'h4'}
            color="black800"
            style={{ fontWeight: 400 }}
          >
            SWAP 接案發展指南
          </Typography>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={() => (window.location.href = 'https://blog.swap.work')}
          >
            <Typography
              variant={'title'}
              color="primary400"
              style={{ marginRight: 2 }}
            >
              查看更多
            </Typography>
            {arrow_right_blue_icon}
          </div>
        </div>
        <div className="post-container">
          <MySlider slidesToShow={smDown ? 1 : mdDown ? 2 : 3}>
            {posts.map((post: any) => (
              <Link
                key={`post-${post?.id}`}
                href={post?.link}
                style={{ textDecoration: 'none' }}
              >
                <SWAPSpace size={40} />
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Paper
                    className="freelance-card"
                    height="auto"
                    style={{
                      padding: '6px 6px 24px',
                      border: 'unset',
                      cursor: 'pointer',
                      boxShadow: '0px 8px 40px 0px rgba(0, 0, 0, 0.12)',
                    }}
                  >
                    <div
                      style={{
                        borderRadius: 10,
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {post?.yoast_head_json?.og_image[0]?.url ? (
                        <Image
                          className="freelance-image"
                          width={385}
                          height={220}
                          objectFit={'cover'}
                          src={post?.yoast_head_json?.og_image[0]?.url}
                        />
                      ) : null}
                    </div>
                    <SWAPSpace size={16} />
                    <div style={{
                      height: 56,
                      padding: '0 18px'
                    }}>
                      <Typography
                        variant={'h5'}
                        color="black1000"
                        style={{
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}
                      >
                        {post?.title?.rendered}
                      </Typography>
                    </div>
                  </Paper>
                </div>
                <SWAPSpace size={40} />
              </Link>
            ))}
          </MySlider>
        </div>
      </div>
    </div>
  )
}

// CTA 區塊
const CtaComponent = ({
  setAuthModal,
}: {
  setAuthModal: (show: boolean) => void
}) => {
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))

  const handleButtonClick = () => {
    if (!ParseAccountToken()) {
      setAuthModal(true)
      return
    }
    window.location.href = '/member'
  }

  return (
    <div
      style={{
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom',
        backgroundSize: 'cover',
        backgroundImage: `url('https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/cta_bg.png')`,
      }}
    >
      <SWAPSpace size={smDown ? 40 : 120} />
      <div className="swap-container">
        <div
          style={{
            width: '100%',
            height: smDown ? 240 : 320,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundImage: `url('https://s3.ap-northeast-1.amazonaws.com/swap-img.swap.work/landingPage4/images/cta_card_bg.png')`,
            borderRadius: 12,
            border: '2px solid #ffffff',
            boxShadow: '0px 8px 40px 0px rgba(0, 0, 0, 0.12)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: 24,
          }}
        >
          <Typography variant={'h6'} color="primary200">
            立即加入 SWAP 吧！
          </Typography>
          <SWAPSpace size={16} />
          <Typography
            variant={smDown ? 'h4' : 'h2'}
            color="white"
            style={{ textAlign: 'center' }}
          >
            從今天開始用 SWAP 體驗事半功倍的接案流程
          </Typography>
          <SWAPSpace size={40} />
          <Button
            size={smDown ? 'medium' : 'large'}
            variant="text"
            style={{ width: smDown ? 103 : 240 }}
            onClick={handleButtonClick}
          >
            立即加入
          </Button>
        </div>
      </div>
      <SWAPSpace size={smDown ? 40 : 120} />
    </div>
  )
}

const LandingPage4 = () => {
  const [authModal, setAuthModal] = useState(false)

  return (
    <LoadToShow>
      <div>
        <style>
          {`
            .swap-container {
              max-width: 1440px;
              margin: 0 auto;
              padding: 0 100px;
            }
            @media(max-width: 767px) {
              .swap-container {
                padding: 0 24px;
              }
            }
            .processes-container {
              padding: 20px 0;
              .slick-list {
                overflow: unset;
              }
            }
            .group-container {
              .slick-list {
                .slick-slide {
                  padding: 0 12px;
                }
              }
              .slick-list {
                overflow: unset;
              }
            }
            .interview-container {
              .slick-list {
                .slick-slide {
                  padding: 0 12px;
                }
              }
            }
            .freelance-container {
              .slick-list {
                overflow: unset;
                .slick-slide {
                  padding: 0 12px;
                }
              }
            }
            .post-container {
              .slick-list {
                .slick-slide {
                  padding: 0 12px;
                }
              }
            }
            .freelance-card {
              .freelance-image {
                transition: transform .4s linear;
              }
            }
            .freelance-card:hover {
              .freelance-image {
                transform: scale(1.05);
              }
            }
            .interview-card {
              transition: background .2s linear;
              .avatar img {
                transition: transform .2s linear;
              }
            }
            .interview-card:hover {
              background: #f2f2f2 !important;
              .avatar img {
                transform: scale(1.1);
              }
            }
            @keyframes rotate{
              0% {
                transform: rotate(0deg);
              }
              100%{
                transform: rotate(360deg);
              }
            }
            ::-webkit-scrollbar {
              display: none;
            }
            `}
        </style>
        <AppHomeHead />
        <Navigation type="soho" page="normal" homePage />
        <div style={{ overflowX: 'hidden' }}>
          <HeroComponent setAuthModal={setAuthModal} />
          <ResumeComponent setAuthModal={setAuthModal} />
          <FunctionsComponent />
          <ProcessesComponent />
          <GroupComponent setAuthModal={setAuthModal} />
          <InterviewComponent />
          <FreelanceComponent />
          <CtaComponent setAuthModal={setAuthModal} />
          <Footer />
        </div>
        {/*SOHO 註冊登入 */}
        <AuthModal
          open={authModal}
          onClose={() => setAuthModal(false)}
          type={'register'}
        />
      </div>
    </LoadToShow>
  )
}

const hero_money_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M7.00004 0.333313C3.32004 0.333313 0.333374 3.31998 0.333374 6.99998C0.333374 10.68 3.32004 13.6666 7.00004 13.6666C10.68 13.6666 13.6667 10.68 13.6667 6.99998C13.6667 3.31998 10.68 0.333313 7.00004 0.333313ZM7.00004 12.3333C4.06004 12.3333 1.66671 9.93998 1.66671 6.99998C1.66671 4.05998 4.06004 1.66665 7.00004 1.66665C9.94004 1.66665 12.3334 4.05998 12.3334 6.99998C12.3334 9.93998 9.94004 12.3333 7.00004 12.3333ZM7.59337 6.39998C6.40671 6.00665 5.83337 5.75998 5.83337 5.13331C5.83337 4.45331 6.57337 4.20665 7.04004 4.20665C7.91337 4.20665 8.23337 4.86665 8.30671 5.09998L9.36004 4.65331C9.26004 4.35998 8.81337 3.37998 7.58671 3.16665V2.33331H6.42004V3.17331C4.68671 3.54665 4.67337 5.07331 4.67337 5.14665C4.67337 6.65998 6.17337 7.08665 6.90671 7.35331C7.96004 7.72665 8.42671 8.06665 8.42671 8.70665C8.42671 9.45998 7.72671 9.77998 7.10671 9.77998C5.89337 9.77998 5.54671 8.53331 5.50671 8.38665L4.40004 8.83331C4.82004 10.2933 5.92004 10.6866 6.41337 10.8066V11.6666H7.58004V10.84C7.92671 10.78 9.59337 10.4466 9.59337 8.69331C9.60004 7.76665 9.19337 6.95331 7.59337 6.39998Z"
      fill="#F7B52C"
    />
  </svg>
)
const hero_file_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.3334 4.00002H8.00004L6.66671 2.66669H2.66671C1.93337 2.66669 1.34004 3.26669 1.34004 4.00002L1.33337 12C1.33337 12.7334 1.93337 13.3334 2.66671 13.3334H13.3334C14.0667 13.3334 14.6667 12.7334 14.6667 12V5.33335C14.6667 4.60002 14.0667 4.00002 13.3334 4.00002ZM13.3334 12H2.66671V4.00002H6.11337L7.44671 5.33335H13.3334V12ZM10 8.66669C10.7334 8.66669 11.3334 8.06669 11.3334 7.33335C11.3334 6.60002 10.7334 6.00002 10 6.00002C9.26671 6.00002 8.66671 6.60002 8.66671 7.33335C8.66671 8.06669 9.26671 8.66669 10 8.66669ZM7.33337 11.3334H12.6667V10.6667C12.6667 9.78002 10.8867 9.33335 10 9.33335C9.11337 9.33335 7.33337 9.78002 7.33337 10.6667V11.3334Z"
      fill="#6C7FD5"
    />
  </svg>
)
const hero_member_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M8 3.33331C7.38116 3.33331 6.78767 3.57915 6.35008 4.01673C5.9125 4.45432 5.66667 5.04781 5.66667 5.66665C5.66667 6.28548 5.9125 6.87898 6.35008 7.31656C6.78767 7.75415 7.38116 7.99998 8 7.99998C8.61884 7.99998 9.21233 7.75415 9.64992 7.31656C10.0875 6.87898 10.3333 6.28548 10.3333 5.66665C10.3333 5.04781 10.0875 4.45432 9.64992 4.01673C9.21233 3.57915 8.61884 3.33331 8 3.33331ZM8 4.66665C8.26522 4.66665 8.51957 4.772 8.70711 4.95954C8.89464 5.14708 9 5.40143 9 5.66665C9 5.93186 8.89464 6.18622 8.70711 6.37375C8.51957 6.56129 8.26522 6.66665 8 6.66665C7.73478 6.66665 7.48043 6.56129 7.29289 6.37375C7.10536 6.18622 7 5.93186 7 5.66665C7 5.40143 7.10536 5.14708 7.29289 4.95954C7.48043 4.772 7.73478 4.66665 8 4.66665ZM3.66667 5.33331C3.22464 5.33331 2.80072 5.50891 2.48816 5.82147C2.17559 6.13403 2 6.55795 2 6.99998C2 7.62665 2.35333 8.16665 2.86 8.45331C3.1 8.58665 3.37333 8.66665 3.66667 8.66665C3.96 8.66665 4.23333 8.58665 4.47333 8.45331C4.72 8.31331 4.92667 8.11331 5.08 7.87331C4.59333 7.23998 4.33333 6.46665 4.33333 5.66665C4.33333 5.60665 4.33333 5.53998 4.33333 5.47998C4.13333 5.38665 3.90667 5.33331 3.66667 5.33331ZM12.3333 5.33331C12.0933 5.33331 11.8667 5.38665 11.6667 5.47998C11.6667 5.53998 11.6667 5.60665 11.6667 5.66665C11.6667 6.46665 11.4067 7.23998 10.92 7.87331C11 7.99998 11.0867 8.09998 11.1867 8.19998C11.2933 8.29998 11.4 8.38665 11.5267 8.45331C11.7667 8.58665 12.04 8.66665 12.3333 8.66665C12.6267 8.66665 12.9 8.58665 13.14 8.45331C13.6467 8.16665 14 7.62665 14 6.99998C14 6.55795 13.8244 6.13403 13.5118 5.82147C13.1993 5.50891 12.7754 5.33331 12.3333 5.33331ZM8 9.33331C6.44 9.33331 3.33333 10.1133 3.33333 11.6666V12.6666H12.6667V11.6666C12.6667 10.1133 9.56 9.33331 8 9.33331ZM3.14 9.69998C1.85333 9.85331 0 10.5066 0 11.6666V12.6666H2V11.38C2 10.7066 2.46 10.1466 3.14 9.69998ZM12.86 9.69998C13.54 10.1466 14 10.7066 14 11.38V12.6666H16V11.6666C16 10.5066 14.1467 9.85331 12.86 9.69998ZM8 10.6666C9.02 10.6666 10.16 11 10.82 11.3333H5.18C5.84 11 6.98 10.6666 8 10.6666Z"
      fill="#10A535"
    />
  </svg>
)
const check_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M19.6667 10.5L17.6334 8.18333L17.9167 5.11666L14.9084 4.43333L13.3334 1.78333L10.5 2.99999L7.66671 1.78333L6.09171 4.43333L3.08337 5.10833L3.36671 8.17499L1.33337 10.5L3.36671 12.8167L3.08337 15.8917L6.09171 16.575L7.66671 19.225L10.5 18L13.3334 19.2167L14.9084 16.5667L17.9167 15.8833L17.6334 12.8167L19.6667 10.5ZM8.83337 14.6667L5.50004 11.3333L6.67504 10.1583L8.83337 12.3083L14.325 6.81666L15.5 7.99999L8.83337 14.6667Z"
      fill="#4862CC"
    />
  </svg>
)
const file_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M17.1666 5.50004H10.5L8.83329 3.83337H3.83329C2.91663 3.83337 2.17496 4.58337 2.17496 5.50004L2.16663 15.5C2.16663 16.4167 2.91663 17.1667 3.83329 17.1667H17.1666C18.0833 17.1667 18.8333 16.4167 18.8333 15.5V7.16671C18.8333 6.25004 18.0833 5.50004 17.1666 5.50004ZM17.1666 15.5H3.83329V5.50004H8.14163L9.80829 7.16671H17.1666V15.5ZM13 11.3334C13.9166 11.3334 14.6666 10.5834 14.6666 9.66671C14.6666 8.75004 13.9166 8.00004 13 8.00004C12.0833 8.00004 11.3333 8.75004 11.3333 9.66671C11.3333 10.5834 12.0833 11.3334 13 11.3334ZM9.66663 14.6667H16.3333V13.8334C16.3333 12.725 14.1083 12.1667 13 12.1667C11.8916 12.1667 9.66663 12.725 9.66663 13.8334V14.6667Z"
      fill="#F59225"
    />
  </svg>
)
const member_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <g clipPath="url(#clip0_18_890)">
      <path
        d="M10.5 4.66663C9.72645 4.66663 8.98459 4.97392 8.43761 5.5209C7.89062 6.06788 7.58333 6.80974 7.58333 7.58329C7.58333 8.35684 7.89062 9.09871 8.43761 9.64569C8.98459 10.1927 9.72645 10.5 10.5 10.5C11.2735 10.5 12.0154 10.1927 12.5624 9.64569C13.1094 9.09871 13.4167 8.35684 13.4167 7.58329C13.4167 6.80974 13.1094 6.06788 12.5624 5.5209C12.0154 4.97392 11.2735 4.66663 10.5 4.66663ZM10.5 6.33329C10.8315 6.33329 11.1495 6.46499 11.3839 6.69941C11.6183 6.93383 11.75 7.25177 11.75 7.58329C11.75 7.91481 11.6183 8.23276 11.3839 8.46718C11.1495 8.7016 10.8315 8.83329 10.5 8.83329C10.1685 8.83329 9.85054 8.7016 9.61612 8.46718C9.3817 8.23276 9.25 7.91481 9.25 7.58329C9.25 7.25177 9.3817 6.93383 9.61612 6.69941C9.85054 6.46499 10.1685 6.33329 10.5 6.33329ZM5.08333 7.16663C4.5308 7.16663 4.0009 7.38612 3.61019 7.77682C3.21949 8.16752 3 8.69742 3 9.24996C3 10.0333 3.44167 10.7083 4.075 11.0666C4.375 11.2333 4.71667 11.3333 5.08333 11.3333C5.45 11.3333 5.79167 11.2333 6.09167 11.0666C6.4 10.8916 6.65833 10.6416 6.85 10.3416C6.24167 9.54996 5.91667 8.58329 5.91667 7.58329C5.91667 7.50829 5.91667 7.42496 5.91667 7.34996C5.66667 7.23329 5.38333 7.16663 5.08333 7.16663ZM15.9167 7.16663C15.6167 7.16663 15.3333 7.23329 15.0833 7.34996C15.0833 7.42496 15.0833 7.50829 15.0833 7.58329C15.0833 8.58329 14.7583 9.54996 14.15 10.3416C14.25 10.5 14.3583 10.625 14.4833 10.75C14.6167 10.875 14.75 10.9833 14.9083 11.0666C15.2083 11.2333 15.55 11.3333 15.9167 11.3333C16.2833 11.3333 16.625 11.2333 16.925 11.0666C17.5583 10.7083 18 10.0333 18 9.24996C18 8.69742 17.7805 8.16752 17.3898 7.77682C16.9991 7.38612 16.4692 7.16663 15.9167 7.16663ZM10.5 12.1666C8.55 12.1666 4.66667 13.1416 4.66667 15.0833V16.3333H16.3333V15.0833C16.3333 13.1416 12.45 12.1666 10.5 12.1666ZM4.425 12.625C2.81667 12.8166 0.5 13.6333 0.5 15.0833V16.3333H3V14.725C3 13.8833 3.575 13.1833 4.425 12.625ZM16.575 12.625C17.425 13.1833 18 13.8833 18 14.725V16.3333H20.5V15.0833C20.5 13.6333 18.1833 12.8166 16.575 12.625ZM10.5 13.8333C11.775 13.8333 13.2 14.25 14.025 14.6666H6.975C7.8 14.25 9.225 13.8333 10.5 13.8333Z"
        fill="#10A535"
      />
    </g>
    <defs>
      <clipPath id="clip0_18_890">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
)
const paper_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.33333 2C2.59333 2 2 2.59333 2 3.33333V12.6667C2 13.4067 2.59333 14 3.33333 14H12.6667C13.4067 14 14 13.4067 14 12.6667V3.33333C14 2.59333 13.4067 2 12.6667 2H3.33333ZM3.33333 3.33333H12.6667V12.6667H3.33333V3.33333ZM4.66667 4.66667V6H11.3333V4.66667H4.66667ZM4.66667 7.33333V8.66667H11.3333V7.33333H4.66667ZM4.66667 10V11.3333H9.33333V10H4.66667Z"
      fill="white"
    />
  </svg>
)
const used_paper_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.58579 1.25253C2.96086 0.877462 3.46957 0.666748 4 0.666748H9.33333C9.51014 0.666748 9.67971 0.736986 9.80474 0.86201L13.8047 4.86201C13.9298 4.98703 14 5.1566 14 5.33341V13.3334C14 13.8638 13.7893 14.3726 13.4142 14.7476C13.0391 15.1227 12.5304 15.3334 12 15.3334H4C3.46957 15.3334 2.96086 15.1227 2.58579 14.7476C2.21071 14.3726 2 13.8638 2 13.3334V2.66675C2 2.13632 2.21071 1.62761 2.58579 1.25253ZM4 2.00008C3.82319 2.00008 3.65362 2.07032 3.5286 2.19534C3.40357 2.32037 3.33333 2.48994 3.33333 2.66675V13.3334C3.33333 13.5102 3.40357 13.6798 3.5286 13.8048C3.65362 13.9298 3.82319 14.0001 4 14.0001H12C12.1768 14.0001 12.3464 13.9298 12.4714 13.8048C12.5964 13.6798 12.6667 13.5102 12.6667 13.3334V5.60956L9.05719 2.00008H4Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33333 0.666748C9.70152 0.666748 10 0.965225 10 1.33341V4.66675H13.3333C13.7015 4.66675 14 4.96522 14 5.33341C14 5.7016 13.7015 6.00008 13.3333 6.00008H9.33333C8.96514 6.00008 8.66667 5.7016 8.66667 5.33341V1.33341C8.66667 0.965225 8.96514 0.666748 9.33333 0.666748Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 8.66675C4.66667 8.29856 4.96514 8.00008 5.33333 8.00008H10.6667C11.0349 8.00008 11.3333 8.29856 11.3333 8.66675C11.3333 9.03494 11.0349 9.33341 10.6667 9.33341H5.33333C4.96514 9.33341 4.66667 9.03494 4.66667 8.66675Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 11.3334C4.66667 10.9652 4.96514 10.6667 5.33333 10.6667H10.6667C11.0349 10.6667 11.3333 10.9652 11.3333 11.3334C11.3333 11.7016 11.0349 12.0001 10.6667 12.0001H5.33333C4.96514 12.0001 4.66667 11.7016 4.66667 11.3334Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 6.00008C4.66667 5.63189 4.96514 5.33341 5.33333 5.33341H6.66667C7.03486 5.33341 7.33333 5.63189 7.33333 6.00008C7.33333 6.36827 7.03486 6.66675 6.66667 6.66675H5.33333C4.96514 6.66675 4.66667 6.36827 4.66667 6.00008Z"
      fill="white"
    />
  </svg>
)
const paper_primary_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5ZM5 5H19V19H5V5ZM7 7V9H17V7H7ZM7 11V13H17V11H7ZM7 15V17H14V15H7Z"
      fill="#4862CC"
    />
  </svg>
)
const used_paper_primary_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V8.41421L13.5858 3H6Z"
      fill="#4862CC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 1C14.5523 1 15 1.44772 15 2V7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H14C13.4477 9 13 8.55228 13 8V2C13 1.44772 13.4477 1 14 1Z"
      fill="#4862CC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13Z"
      fill="#4862CC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 17C7 16.4477 7.44772 16 8 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17Z"
      fill="#4862CC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 9C7 8.44772 7.44772 8 8 8H10C10.5523 8 11 8.44772 11 9C11 9.55229 10.5523 10 10 10H8C7.44772 10 7 9.55229 7 9Z"
      fill="#4862CC"
    />
  </svg>
)
const paper_primary_mobile_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M5 3.33984C3.89 3.33984 3 4.22984 3 5.33984V19.3398C3 20.4498 3.89 21.3398 5 21.3398H19C20.11 21.3398 21 20.4498 21 19.3398V5.33984C21 4.22984 20.11 3.33984 19 3.33984H5ZM5 5.33984H19V19.3398H5V5.33984ZM7 7.33984V9.33984H17V7.33984H7ZM7 11.3398V13.3398H17V11.3398H7ZM7 15.3398V17.3398H14V15.3398H7Z"
      fill="#4862CC"
    />
  </svg>
)
const used_paper_primary_mobile_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M3.23223 1.76422C3.70107 1.29537 4.33696 1.03198 5 1.03198H11.6667C11.8877 1.03198 12.0996 1.11978 12.2559 1.27606L17.2559 6.27606C17.4122 6.43234 17.5 6.6443 17.5 6.86532V16.8653C17.5 17.5284 17.2366 18.1642 16.7678 18.6331C16.2989 19.1019 15.663 19.3653 15 19.3653H5C4.33696 19.3653 3.70107 19.1019 3.23223 18.6331C2.76339 18.1642 2.5 17.5284 2.5 16.8653V3.53198C2.5 2.86894 2.76339 2.23306 3.23223 1.76422ZM5 2.69865C4.77899 2.69865 4.56702 2.78645 4.41074 2.94273C4.25446 3.09901 4.16667 3.31097 4.16667 3.53198V16.8653C4.16667 17.0863 4.25446 17.2983 4.41074 17.4546C4.56702 17.6109 4.77899 17.6986 5 17.6986H15C15.221 17.6986 15.433 17.6109 15.5893 17.4546C15.7455 17.2983 15.8333 17.0863 15.8333 16.8653V7.21049L11.3215 2.69865H5Z"
      fill="#4862CC"
    />
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M11.6667 1.03198C12.1269 1.03198 12.5 1.40508 12.5 1.86532V6.03198H16.6667C17.1269 6.03198 17.5 6.40508 17.5 6.86532C17.5 7.32555 17.1269 7.69865 16.6667 7.69865H11.6667C11.2064 7.69865 10.8333 7.32555 10.8333 6.86532V1.86532C10.8333 1.40508 11.2064 1.03198 11.6667 1.03198Z"
      fill="#4862CC"
    />
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M5.83333 11.032C5.83333 10.5717 6.20643 10.1986 6.66667 10.1986H13.3333C13.7936 10.1986 14.1667 10.5717 14.1667 11.032C14.1667 11.4922 13.7936 11.8653 13.3333 11.8653H6.66667C6.20643 11.8653 5.83333 11.4922 5.83333 11.032Z"
      fill="#4862CC"
    />
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M5.83333 14.3653C5.83333 13.9051 6.20643 13.532 6.66667 13.532H13.3333C13.7936 13.532 14.1667 13.9051 14.1667 14.3653C14.1667 14.8256 13.7936 15.1986 13.3333 15.1986H6.66667C6.20643 15.1986 5.83333 14.8256 5.83333 14.3653Z"
      fill="#4862CC"
    />
    <path
      fill-rule="evenodd"
      clipRule="evenodd"
      d="M5.83333 7.69865C5.83333 7.23841 6.20643 6.86532 6.66667 6.86532H8.33333C8.79357 6.86532 9.16667 7.23841 9.16667 7.69865C9.16667 8.15889 8.79357 8.53198 8.33333 8.53198H6.66667C6.20643 8.53198 5.83333 8.15889 5.83333 7.69865Z"
      fill="#4862CC"
    />
  </svg>
)
const arrow_up_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16.59 15.4199L12 10.8299L7.41 15.4199L6 13.9999L12 7.99992L18 13.9999L16.59 15.4199Z"
      fill="#6F6F6F"
    />
  </svg>
)
const arrow_down_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.41 8.58008L12 13.1701L16.59 8.58008L18 10.0001L12 16.0001L6 10.0001L7.41 8.58008Z"
      fill="#6F6F6F"
    />
  </svg>
)
const arrow_right_white_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.33337 9.16669V10.8334H13.3334L8.75004 15.4167L9.93337 16.6L16.5334 10L9.93337 3.40002L8.75004 4.58336L13.3334 9.16669H3.33337Z"
      fill="white"
    />
  </svg>
)
const arrow_right_blue_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M8.58997 17.08L13.17 12.5L8.58997 7.91L9.99997 6.5L16 12.5L9.99997 18.5L8.58997 17.08Z"
      fill="#4862CC"
    />
  </svg>
)
const arrow_down_blue_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M14.6667 5.33337H17.3333V21.3334L24.6667 14L26.56 15.8934L16 26.4534L5.43999 15.8934L7.33332 14L14.6667 21.3334V5.33337Z"
      fill="#4862CC"
    />
  </svg>
)
const double_quotation_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="81"
    viewBox="0 0 80 81"
    fill="none"
  >
    <path
      d="M33.3333 23.8335L26.6666 37.1668H36.6666V57.1668H16.6666V37.1668L23.3333 23.8335H33.3333ZM60 23.8335L53.3333 37.1668H63.3333V57.1668H43.3333V37.1668L50 23.8335H60Z"
      fill="#E6E9F8"
    />
  </svg>
)
const double_quotation_mobile_icon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
  >
    <path
      d="M20 14.9341L16 22.9341H22V34.9341H10V22.9341L14 14.9341H20ZM36 14.9341L32 22.9341H38V34.9341H26V22.9341L30 14.9341H36Z"
      fill="#E6E9F8"
    />
  </svg>
)
const icon_success_white = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M21 6.99984L9 18.9998L3.5 13.4998L4.91 12.0898L9 16.1698L19.59 5.58984L21 6.99984Z"
      fill="white"
    />
  </svg>
)
const icon_close_white = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
      fill="white"
    />
  </svg>
)
export default LandingPage4
